import { render, staticRenderFns } from "./ClassTable.vue?vue&type=template&id=5ed9b9b5"
import script from "./ClassTable.vue?vue&type=script&lang=js"
export * from "./ClassTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports